export default __webpack_public_path__ + "static/media/98f45177630f4d45ca6a467a6f6d27c0.svg";